import Link from "next/link";
import { sanifyProductTitle } from "@repo/next-shared/utils";
import { Highlight } from "react-instantsearch";

export default function AlgoliaAutocompleteHit({ hit }: { hit: any }) {
  const productId = hit?.objectID.split("-")[0];

  return (
    <Link href={`/product/${productId}/${sanifyProductTitle(hit?.titleIt)}`}>
      <article className="flex gap-4">
        <div className="max-w-[100px] max-md:max-w-[50px] flex items-center">
          <img src={hit.image} alt={hit.name} />
        </div>
        <section className="text-left pt-[10px]">
          <h4 className="leading-none">
            <Highlight
              attribute="titleIt"
              hit={hit}
              classNames={{
                highlighted: "bg-primary-magenta text-primary-white",
              }}
            />
          </h4>
          <p>{hit.brand}</p>
          <p>{hit.minVariantTargetPrice} €</p>
        </section>
      </article>
    </Link>
  );
}
